import React, { useState, useCallback, useRef } from 'react';
import Lightbox from 'react-images';
import Slider from 'react-slick';
import { useInView } from 'react-intersection-observer';
import SliderArrow from './SliderArrow';
import useSlides from '../hooks/useSlides';
import { CloseLightbox } from './InstagramSlider';
import GalleryImage from './GalleryImage';

export default function PhotoGallery({ photos }) {
  const ref = useRef(null);
  const [inViewRef, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  const slideCount = useSlides({ sliderRef: ref, cardWidth: 220 });

  const [showLightbox, toggleLightbox] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: slideCount || 3,
    slidesToScroll: slideCount || 3,
    arrows: true,
    prevArrow: <SliderArrow type="instagram" direction="prev" />,
    nextArrow: <SliderArrow type="instagram" direction="next" />,
  };

  const setRefs = useCallback(
    node => {
      // Ref's from useRef needs to have the node assigned to `current`
      ref.current = node;
      // Callback refs, like the one from `useInView`, is a function that takes the node as an argument
      inViewRef(node);
    },
    [inViewRef]
  );

  return (
    <div ref={setRefs} className="gallery-container">
      {inView && (
        <>
          <Lightbox
            onClose={() => toggleLightbox(false)}
            onClickNext={() => setImageIndex(imageIndex + 1)}
            onClickPrev={() => setImageIndex(imageIndex - 1)}
            currentImage={imageIndex}
            isOpen={showLightbox}
            images={photos.map(photo => ({
              src: photo.large_image_url,
            }))}
            onClickThumbnail={e => setImageIndex(e)}
            customControls={[
              <CloseLightbox onClick={() => toggleLightbox(false)} />,
            ]}
            closeButtonTitle="closeLightbox"
            leftArrowTitle="leftLightboxArrow"
            rightArrowTitle="rightLightboxArrow"
            showImageCount={false}
            showThumbnails
          />
          <Slider {...settings}>
            {photos.map((photo, ind) => (
              <GalleryImage
                key={ind}
                image={photo}
                onClick={() => {
                  setImageIndex(ind);
                  toggleLightbox(true);
                }}
              />
            ))}
          </Slider>
        </>
      )}
    </div>
  );
}
